import { createSlice } from '@reduxjs/toolkit';

export type SelectionState = Record<string, boolean>;

const initialState: SelectionState = {};

export const selectionSlice = createSlice({
    name: 'selection',
    initialState,
    reducers: {
        select: (state, action) => {
            state[action.payload] = true;
        },
        unselect: (state, action) => {
            state[action.payload] = false;
        },
        set: (state, action) => action.payload,
    },
});

export const selectionSelectors = {
    isSelected: (state: SelectionState, id: string) => state[id],
};
